var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-empty',{staticClass:"custom-image",attrs:{"image":require('@/assets/errors-empty.png'),"description":"你好厉害呀 到目前为止都没有错题"}})}
var staticRenderFns = []

export { render, staticRenderFns }